$(document).ready(function () {
    $('.new_product-tabs__radio').on('change', function () {
        var radioDataDef = $(this).attr('data-tab-panel');
        var abcParent = $(this).closest('.product-tabs').find('.product-tabs__panel[data-tab-panel="' + radioDataDef + '"]');

        // Hide all panels
        $('.product-tabs__panel').css('display','none');

        // Display the selected panel
        abcParent.css('display','block');
    });

    $('.main-carousel').flickity({
        // options
        cellAlign: 'left',
        autoPlay: false,
        prevNextButtons: true,
        adaptiveHeight: true
        // contain: true

      });

});

let stickyFtrAtcId = document.querySelector("#ftr_sticky_atc");
let headerAtc = document.querySelector(".cstm_header_atc")
// console.log(headerAtc);
// console.log(stickyFtrAtcId);

if (stickyFtrAtcId) {
    // console.log('inif');
    
    let stickyFtrAtcInput = stickyFtrAtcId.querySelector('.quantity-wrapper input');
    let headerAtcInput = document.querySelector(".cstm_header_atc .quantity-wrapper input");

    stickyFtrAtcId.querySelector('.quantity-wrapper .downer').addEventListener("click", function() {
        stickyFtrAtcInput.value = headerAtcInput.value;
    });
    stickyFtrAtcId.querySelector('.quantity-wrapper .upper').addEventListener("click", function() {
        stickyFtrAtcInput.value = headerAtcInput.value;
    });

    headerAtc.querySelector('.quantity-wrapper .upper').addEventListener("click", function() {
        stickyFtrAtcInput.value = headerAtcInput.value;
    });
    headerAtc.querySelector('.quantity-wrapper .downer').addEventListener("click", function() {
        stickyFtrAtcInput.value = headerAtcInput.value;
    });

}


(function () {
    function patchTrackingPixel(img) {
        if (!img || img.nodeType !== 1 || img.getAttribute('data-a11y-tracking-patched') === 'true') {
            return;
        }

        var src = img.currentSrc || img.getAttribute('src') || '';
        if (!src || !/roeye\.com|lantern\.roeye\.com|track\.php/i.test(src)) {
            return;
        }

        img.setAttribute('alt', '');
        img.setAttribute('aria-hidden', 'true');
        img.setAttribute('role', 'presentation');
        img.setAttribute('data-a11y-tracking-patched', 'true');
    }

    function headingHasMeaningfulContent(heading) {
        if (!heading) {
            return false;
        }

        var ariaLabel = heading.getAttribute('aria-label');
        if (ariaLabel && ariaLabel.trim() !== '') {
            return true;
        }

        var clone = heading.cloneNode(true);
        var removableNodes = clone.querySelectorAll('script, style, br');
        removableNodes.forEach(function (node) {
            node.remove();
        });

        var labelledImages = clone.querySelectorAll('img[alt]');
        for (var i = 0; i < labelledImages.length; i += 1) {
            if ((labelledImages[i].getAttribute('alt') || '').trim() !== '') {
                return true;
            }
        }

        var labelledDescendant = clone.querySelector('[aria-label]');
        if (labelledDescendant && (labelledDescendant.getAttribute('aria-label') || '').trim() !== '') {
            return true;
        }

        return (clone.textContent || '').replace(/\u00a0/g, ' ').trim() !== '';
    }

    function selectorEscape(value) {
        return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    }

    function removeEmptyHeadings(scope) {
        var roots = [];
        var headings = [];

        if (scope && scope.nodeType === 1) {
            roots.push(scope);
        } else if (document.body) {
            roots.push(document.body);
        } else {
            roots.push(document);
        }

        roots.forEach(function (root) {
            if (root.matches && root.matches('h1, h2, h3, h4, h5, h6')) {
                headings.push(root);
            }

            if (root.querySelectorAll) {
                headings = headings.concat(Array.prototype.slice.call(root.querySelectorAll('h1, h2, h3, h4, h5, h6')));
            }
        });

        headings.forEach(function (heading) {
            if (!headingHasMeaningfulContent(heading)) {
                heading.remove();
            }
        });
    }

    function hasAssociatedLabel(control) {
        if (!control || control.nodeType !== 1) {
            return false;
        }

        if (control.closest && control.closest('label')) {
            return true;
        }

        if (!control.id) {
            return false;
        }

        return !!document.querySelector('label[for="' + selectorEscape(control.id) + '"]');
    }

    function dedupeOkendoLabels(scope) {
        var root = scope && scope.querySelectorAll ? scope : document;
        var controls = [];

        if (root.nodeType === 1 && root.matches && root.matches('.okeReviews select[aria-label], .okeReviews input[aria-label], .okeReviews textarea[aria-label], [data-oke-widget] select[aria-label], [data-oke-widget] input[aria-label], [data-oke-widget] textarea[aria-label]')) {
            controls.push(root);
        }

        if (root.querySelectorAll) {
            controls = controls.concat(Array.prototype.slice.call(root.querySelectorAll('.okeReviews select[aria-label], .okeReviews input[aria-label], .okeReviews textarea[aria-label], [data-oke-widget] select[aria-label], [data-oke-widget] input[aria-label], [data-oke-widget] textarea[aria-label]')));
        }

        controls.forEach(function (control) {
            if (control.getAttribute('data-a11y-label-deduped') === 'true') {
                return;
            }

            if (hasAssociatedLabel(control)) {
                control.removeAttribute('aria-label');
                control.setAttribute('data-a11y-label-deduped', 'true');
            }
        });
    }

    function applyCmsA11yFixes(scope) {
        var root = scope && scope.querySelectorAll ? scope : document;
        var trackingImages = [];

        if (root.nodeType === 1 && root.tagName === 'IMG') {
            trackingImages.push(root);
        }

        if (root.querySelectorAll) {
            trackingImages = trackingImages.concat(Array.prototype.slice.call(root.querySelectorAll('img')));
        }

        trackingImages.forEach(patchTrackingPixel);
        removeEmptyHeadings(root);
        dedupeOkendoLabels(root);
    }

    function initCmsA11yFixes() {
        applyCmsA11yFixes(document);

        if (!document.body || typeof MutationObserver === 'undefined') {
            return;
        }

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType === 1) {
                        applyCmsA11yFixes(node);
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCmsA11yFixes);
    } else {
        initCmsA11yFixes();
    }
})();




// if (document.querySelector('.fut_wrapper')) {
//     function stickyAddToCart() {
//         let futWrapper = document.querySelector('.shopify-product-form');
//         let futOffset = futWrapper.offsetTop;
//         futOffset = futOffset + futWrapper.offsetHeight + 200;
    
//         if (futOffset <  window.scrollY) {
//             !document.querySelector('.footer_atc_wrapper') ? document.querySelector('.fut_wrapper').classList.add('footer_atc_wrapper') : null;
//             !document.querySelector('.footer_atc') ? document.querySelector('.fut_atc').classList.add('footer_atc') : null;
//             document.querySelector('.footer_atc_wrapper') ? document.body.style.paddingBottom = document.querySelector('.footer_atc_wrapper').offsetHeight + 'px' : null;
//         }
//         else{
//             document.querySelector('.footer_atc_wrapper') ? document.querySelector('.footer_atc_wrapper').classList.remove('footer_atc_wrapper') : null;
//             document.querySelector('.footer_atc') ? document.querySelector('.footer_atc').classList.remove('footer_atc') : null;
//             document.querySelector('.footer_atc_wrapper') ? null : document.body.style.paddingBottom = 0;
//         }
//     }
//     stickyAddToCart()
    
//     window.addEventListener('scroll',stickyAddToCart)  
// }
